module.exports = __webpack_public_path__ + "static/media/transplantation-Figure8-L.fb3cdba1.jpg";